module.exports = __webpack_public_path__ + "img/int3_mob.f868021b.png";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":810,"height":525,"variants":[{"file":"img/int3_mob-480w.4b9e7e144e19.webp","width":480},{"file":"img/int3_mob-810w.3cb427caf6a8.webp","width":810}]};
}